import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stringIncludes',
  standalone: true,
})
export class StringIncludesPipe implements PipeTransform {
  transform(value: string, search: string | string[]): boolean {
    if (!value?.length || !search) return false;

    const searchArray: string[] = Array.isArray(search) ? search : [search];

    return searchArray.some((term: string) => {
      return value.includes(term);
    });
  }
}
